/* eslint-disable import/prefer-default-export */
import { reduce } from 'lodash';
import { Dayjs } from 'dayjs';
import { useMemo } from 'react';
import { USA_DATE } from '../../../../constants/timeFormat';
import { BOTableDataType } from '../../type/BOTypes';
import { MeasurementHelper } from '../../helper/MeasurementHelper';
import { BOMeasurementService } from '../../helper/BOMeasurementService';
import { Measurement } from '../../../../uc-api-sdk';
import { NonNullUndefined } from '../../../../types/common';

export const useBOResultToTable = (
  data: NonNullUndefined<Measurement>[],
  fromDate: Dayjs,
  toDate: Dayjs,
) => {
  const processedData = useMemo(() => {
    // create a table with date as the key and array of measurements as the value
    const dateValueDict = MeasurementHelper.dateValueDict(data);

    // uses the table above to a the date create a
    // new table mealType as the key and array of measurements
    // as the value
    const getData = (date: string) => {
      const valuesInDay = dateValueDict[date];
      if (!valuesInDay) {
        return {};
      }
      const unsortedObject = reduce(valuesInDay, (res, curr) => {
        const timeOfDay = curr.timeOfTheDay;
        if (res[timeOfDay] === undefined) {
          res[timeOfDay] = [];
        }
        res[timeOfDay]?.push(new BOMeasurementService(curr));
        return res;
      }, {} as BOTableDataType['data']);

      return MeasurementHelper.sortByDate(unsortedObject);
    };

    return MeasurementHelper.createArrayOfDateData(
      fromDate,
      toDate,
      (date: Dayjs) => getData(date.format(USA_DATE)),
    ).reverse();
  }, [data, fromDate, toDate]);

  return processedData;
};
